"use client";

import staticData from "@/public/data/flight/results.json";
import { Pulse } from "@/shared/components/common/Animations";
import Flex from "@/shared/components/common/Flex";
import PhosphorIcon from "@/shared/components/common/PhosphorIcon";
import Typography from "@/shared/components/common/Typography";
import { useDeviceType } from "@/shared/context/DeviceContext";
import Link from "next/link";
import { useState } from "react";

interface FlightCardActionButtonProps {
  nextPageUrl: string;
  isBooked: boolean;
  remainingSeats: number | null;
  setFlightKey: () => void;
}

export default function FlightCardActionButton({
  nextPageUrl,
  isBooked,
  remainingSeats,
  setFlightKey,
}: FlightCardActionButtonProps) {
  const { closedFlightLabel, remainingSeatsLabel } = staticData.resultCard;

  const [loading, setLoading] = useState<boolean>(false);

  const FlightCardActionButton = (
    <Flex direction={"col"} alignItems={"center"} gap={"1"}>
      <Flex
        alignItems={"center"}
        justifyContent={"center"}
        gap={"1"}
        className={`max-md:w-full md:flex min-h-12 group min-w-36 rounded-full px-4 py-2 md:bg-primary hover:bg-primary-90 transition-[background] duration-100 ease-easeInOutCirc ${loading ? "opacity-50" : ""}`}
      >
        <PhosphorIcon
          name="Seat"
          size={20}
          weight="fill"
          className="md:hidden text-black !transform !scale-x-[-1] animate-pulse duration-[2s]"
        />
        {loading ?
          <Pulse />
          :
          <>
            <Flex.Item>
              <Flex
                alignItems={"center"}
                gap={"1"}
                className="text-red-500 dark:text-foreground md:text-background rounded px-2 py-1"
              >
                <Typography
                  variant="caption"
                  className="text-sm md:text-base font-bold"
                >
                  {isBooked && remainingSeats === 0
                    ? closedFlightLabel
                    : remainingSeats}
                </Typography>
                <Typography
                  variant="caption"
                  className="text-sm md:text-base md:font-medium"
                >
                  {isBooked && remainingSeats === 0
                    ? closedFlightLabel
                    : remainingSeatsLabel}
                </Typography>
              </Flex>
            </Flex.Item>
            <PhosphorIcon
              name="CaretLeft"
              size={20}
              weight="regular"
              className="hidden md:block text-background dark:text-foreground group-hover:-translate-x-3 transition duration-100 ease-easeInOutCirc"
            />
          </>
        }
      </Flex>
    </Flex>
  );

  const handleClick = () => {
    if (!loading) {
      setLoading(true);
      setFlightKey();
    }
  };

  return useDeviceType() === "mobile" ? (
    FlightCardActionButton
  ) : (
    <Link
      href={nextPageUrl}
      onClick={handleClick}
      className={`max-md:w-full ${loading ? "cursor-auto" : ""}`}
    >
      {FlightCardActionButton}
    </Link>
  );
}
